var _SEVERITY_MAP;

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

import React, { memo, useCallback, useState } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import ErrorIcon from '@material-ui/icons/ErrorOutline';
import { TOASTR_SEVERITY_ERROR, TOASTR_SEVERITY_SUCCESS, TOASTR_SEVERITY_SUCCESS_PERSISTENT, TOASTR_SEVERITY_WARNING } from './constants';
import { CloseIconWhite, DoneIcon, ErrorIconWhite, ToastrTypography, Wrapper } from './styles';
import ToastrContext from './Context';
var SEVERITY_MAP = (_SEVERITY_MAP = {}, _defineProperty(_SEVERITY_MAP, TOASTR_SEVERITY_ERROR, {
  SeverityIcon: ErrorIconWhite,
  CloseIcon: CloseIconWhite,
  typographyColor: 'inverse'
}), _defineProperty(_SEVERITY_MAP, TOASTR_SEVERITY_SUCCESS, {
  autoHideDuration: 5000,
  SeverityIcon: DoneIcon,
  CloseIcon: CloseIconWhite,
  typographyColor: 'inverse'
}), _defineProperty(_SEVERITY_MAP, TOASTR_SEVERITY_SUCCESS_PERSISTENT, {
  SeverityIcon: DoneIcon,
  CloseIcon: CloseIconWhite,
  typographyColor: 'inverse'
}), _defineProperty(_SEVERITY_MAP, TOASTR_SEVERITY_WARNING, {
  SeverityIcon: ErrorIcon,
  CloseIcon: CloseIcon,
  typographyColor: 'inherit'
}), _SEVERITY_MAP);
var defaultSeverity = SEVERITY_MAP[TOASTR_SEVERITY_SUCCESS];
export function Toastr(_ref) {
  var children = _ref.children;

  var _useState = useState({}),
      _useState2 = _slicedToArray(_useState, 2),
      _useState2$ = _useState2[0],
      message = _useState2$.message,
      severity = _useState2$.severity,
      setToastrState = _useState2[1];

  var _ref2 = SEVERITY_MAP[severity] || defaultSeverity,
      CloseIcon = _ref2.CloseIcon,
      SeverityIcon = _ref2.SeverityIcon,
      autoHideDuration = _ref2.autoHideDuration,
      typographyColor = _ref2.typographyColor;

  var toastrContext = {
    showToastMessage: useCallback(function (message) {
      var severity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TOASTR_SEVERITY_SUCCESS;
      setToastrState({
        message: message,
        severity: severity
      });
    }, [setToastrState]),
    showToastMessagePersistent: useCallback(function (message) {
      var severity = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : TOASTR_SEVERITY_SUCCESS_PERSISTENT;
      setToastrState({
        message: message,
        severity: severity
      });
    }, [setToastrState]),
    showToastError: useCallback(function (message) {
      setToastrState({
        message: message,
        severity: TOASTR_SEVERITY_ERROR
      });
    }, [setToastrState])
  };
  var handleClose = useCallback(function (event, reason) {
    if (reason === 'clickaway') {
      return;
    }

    setToastrState({});
  }, [setToastrState]);
  return /*#__PURE__*/React.createElement(ToastrContext.Provider, {
    value: toastrContext
  }, children, /*#__PURE__*/React.createElement(Snackbar, {
    open: !!message,
    autoHideDuration: autoHideDuration,
    onClose: handleClose
  }, /*#__PURE__*/React.createElement(Wrapper, {
    open: !!message,
    severity: severity
  }, /*#__PURE__*/React.createElement(SeverityIcon, {
    fontSize: "small"
  }), /*#__PURE__*/React.createElement(ToastrTypography, {
    color: typographyColor
  }, message), /*#__PURE__*/React.createElement(IconButton, {
    size: "small",
    "aria-label": "close",
    onClick: handleClose
  }, /*#__PURE__*/React.createElement(CloseIcon, {
    fontSize: "small"
  })))));
}
export default /*#__PURE__*/memo(Toastr);